import { render } from "./IconPerformanceHalfTime.vue?vue&type=template&id=1a3144d7&ts=true"
import script from "./IconPerformanceHalfTime.vue?vue&type=script&lang=ts"
export * from "./IconPerformanceHalfTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__